import { render, staticRenderFns } from "./ProgramImportDropZoneForm.vue?vue&type=template&id=01bbdcf4"
import script from "./ProgramImportDropZoneForm.vue?vue&type=script&lang=js"
export * from "./ProgramImportDropZoneForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports